"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileDrawingTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const TileDrawingTableRowItem_1 = require("./TileDrawingTableRowItem");
const dictionary_1 = require("../../../../TableCore/dictionary");
const TileDrawingTable = ({ rows, showMoreLabel, showLessLabel, }) => {
    const SHOWED_ROWS_COUNT = React.useRef(3);
    const [isExpended, setIsExpended] = React.useState(false);
    const { showedRows, extraRows } = React.useMemo(() => {
        const showedRows = rows.slice(0, SHOWED_ROWS_COUNT.current);
        const extraRows = rows.slice(SHOWED_ROWS_COUNT.current);
        return { showedRows, extraRows };
    }, [rows]);
    const columns = React.useMemo(() => [
        dictionary_1.tableDictionary.name,
        dictionary_1.tableDictionary.type,
        dictionary_1.tableDictionary.updated,
        dictionary_1.tableDictionary.fileType,
        dictionary_1.tableDictionary.download,
    ], []);
    const isExpendable = React.useMemo(() => (extraRows.length > 0 ? true : false), [extraRows.length]);
    const toggleExpendTable = React.useCallback(() => {
        setIsExpended(prev => !prev);
    }, []);
    const capitalize = React.useCallback(column => {
        return (0, app_1.capitalizeFirstLetter)(column);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("table", { className: "table table-auto", children: [(0, jsx_runtime_1.jsx)("thead", { className: "hidden md:table-header-group", children: (0, jsx_runtime_1.jsx)("tr", { children: columns.map(column => ((0, jsx_runtime_1.jsx)("th", { className: "first-child:w-[36%]", children: capitalize(column) }, column))) }) }), (0, jsx_runtime_1.jsxs)("tbody", { children: [showedRows.map(row => ((0, jsx_runtime_1.jsx)(TileDrawingTableRowItem_1.default, { row: row }, row.url))), isExpended && extraRows.map(row => (0, jsx_runtime_1.jsx)(TileDrawingTableRowItem_1.default, { row: row }, row.url))] })] }), isExpendable && ((0, jsx_runtime_1.jsx)("button", { className: "text-btn-primary w-fit", onClick: toggleExpendTable, children: isExpended ? showLessLabel : showMoreLabel }))] }));
};
exports.TileDrawingTable = TileDrawingTable;
